import { NgModule } from '@angular/core';
import { PageNotFoundComponent } from './page-not-found.component';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TranslationModule } from 'src/app/modules/i18n/translation.module';

@NgModule({
  declarations: [PageNotFoundComponent],
  imports: [
    ButtonModule,
    CardModule,
    TranslationModule
  ],
})
export class PageNotFoundModule {}
